import {makeStyles} from "@material-ui/core/styles";
import {openSideWidth, closeSideWidth, topHeight} from "../../../stores/NavigateStore";

export const  useStyles = makeStyles((theme) => ({
    drawer:{
        width: openSideWidth,
        background:'#fff',
        boxShadow:'0px 7px 10px 0px rgba(61, 61, 61, 0.20)',
    },
    drawerOpen: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        overflowX: 'hidden',
        width: closeSideWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    logoBox:{
        height: topHeight,
        boxSizing:'border-box',
        padding: '0 10px 0 20px',
        '& p':{
            fontSize: '1.375rem',
            color: '#5579F0',
            fontWeight: 700,
        }
    },
    closeLogoBox:{
        height: topHeight,
    },
    iconButton:{
        padding: 0,
        '&:hover':{
            background: 'transparent'
        },
    },
    menuBox:{
        marginTop: 30,
        padding: '0 5px',
        boxSizing:'border-box',
        '& ul':{
            padding: 0
        },
    },
    listItemStyle:{
        height: 44,
        // background: 'rgba(85, 121, 240, 0.08)',
        borderRadius: 8,
        padding: '0 15px',
        '&:hover':{
            // background: 'rgba(85, 121, 240, 0.08)',
        },
        '& .MuiListItemIcon-root':{
            minWidth: 20,
        },
        '& .MuiListItemText-root':{
            '& span':{
                fontSize: '0.875rem',
                fontWeight: 700,
                color: '#5579F0',
                marginLeft: 10
            }
        }
    },
    selectListItemStyle:{
        background: 'rgba(85, 121, 240, 0.08)',
        '&:hover':{
            background: 'rgba(85, 121, 240, 0.08)',
        },
    },
    sideLogin: {
        position: 'absolute',
        bottom: 30,
        left: 22,
        zIndex: 9999,
        '& .MuiButtonBase-root': {
            padding: 0,
            minWidth: 'auto',
            '&:hover': {
                background: 'transparent'
            }
        },
        '& .MuiTypography-root': {
            fontSize: '0.875rem',
            color: '#666',
            marginLeft: 5,
        }
    },
    loginClose: {
        left: 22,
    }
}));

